<ng-container *ngIf="isEnabled" [ngSwitch]="type">
	<!-- BANNER -->
	<ng-adsense *ngSwitchCase="googleAd.BANNER" [adSlot]="googleAdBanner.adSlot" [className]="googleAdBanner.className"></ng-adsense>

	<!-- FEED -->
	<ng-adsense
		*ngSwitchCase="googleAd.FEED"
		[adSlot]="googleAdFeed.adSlot"
		[adFormat]="googleAdFeed.adFormat"
		[layoutKey]="googleAdFeed.layoutKey"
		[className]="googleAdBanner.className"
	></ng-adsense>

	<!-- Multiplex -->
	<ng-adsense *ngSwitchCase="googleAd.MULTIPLEX" [adSlot]="googleAdFeed.adSlot" [className]="googleAdBanner.className"></ng-adsense>
</ng-container>
